import { useCallback, useContext } from 'react';
import { useLanguage } from '@xolv-mybrightlink/common';
import { RemoteI18nContext } from './RemoteI18nDataProvider';

export const useRemoteI18n = () => {
  const remoteI18n = useContext(RemoteI18nContext);
  const { language } = useLanguage();
  return useCallback(
    (key: string, args: string[] = []): string => {
      if (!remoteI18n) {
        return '';
      }
      let text = remoteI18n[language][key];
      if (text) {
        const regex = /{\d*}/;
        args.forEach((arg) => (text = text.replace(regex, arg)));
        return text;
      }
      console.debug(
        `Unknown remote i18n data for key ${key}. Fallback to key instead`,
      );
      return key;
    },
    [remoteI18n, language],
  );
};
